import React from 'react';
import PropTypes from 'prop-types';
import Message, {getMessage} from '../../common/Message';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';
import styles from './EulaFormSection.pcss';
import signupStyles from '../../../pages/signup/SignUp.pcss';
import ConductDialog from '../../../components/eula/ConductDialog';
import AffiliateDialog from '../../../components/eula/AffiliateDialog';

export default class EulaFormSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        loading: PropTypes.bool,
        failedToFetch: PropTypes.bool,
        updateGuardianStatus: PropTypes.func,
        guardianAcknowledgment: PropTypes.bool,
        guardianAccepted: PropTypes.bool,
        acceptedAgreement: PropTypes.bool,
        acceptedConduct: PropTypes.bool,
        updateConductStatus: PropTypes.func,
        updateAgreementStatus: PropTypes.func
    };

    state = {
        showAffiliate: false,
        showConduct: false
    };

    openConduct = event => {
        event.stopPropagation();
        this.setState({
            showConduct: true
        });
    };

    openAffiliate = event => {
        event.stopPropagation();
        this.setState({
            showAffiliate: true
        });
    };

    closeAffiliate = () => {
        this.setState({
            showAffiliate: false
        });
    };

    closeConduct = () => {
        this.setState({
            showConduct: false
        });
    };

    render() {
        const {loading, messages, failedToFetch, guardianAcknowledgment} = this.props;

        return (
            <div className={signupStyles.header}>
                <h2>
                    <Message code="epic.affiliate.signup.code_of_conduct.title" />
                    {' *'}
                </h2>

                <p>
                    <Message code="epic.affiliate.signup.code_of_conduct.body" />
                </p>

                <div className={styles.eulaSection}>
                    <ConductDialog open={this.state.showConduct} onClose={this.closeConduct} />
                    <AffiliateDialog
                        open={this.state.showAffiliate}
                        onClose={this.closeAffiliate}
                    />
                    <div className={styles.eulaAccept}>
                        {!loading && !failedToFetch && (
                            <div>
                                <CheckBox
                                    name="agreementAccepted"
                                    validations="checked"
                                    validationError={getMessage(
                                        messages,
                                        'ui.form.agreement.required'
                                    )}
                                    value={this.props.acceptedAgreement}
                                    onChange={this.props.updateAgreementStatus}>
                                    <Message code="epic.affiliate.signup.code_of_conduct.acknowledge">
                                        <span
                                            className={styles.details}
                                            onClick={this.openAffiliate}
                                            dangerouslySetInnerHTML={{
                                                __html: ` ${getMessage(
                                                    messages,
                                                    'epic.affiliate.signup.code_of_conduct.affiliate_agreement'
                                                )}`
                                            }}
                                        />
                                    </Message>
                                </CheckBox>
                            </div>
                        )}
                        {!loading && !failedToFetch && (
                            <div>
                                <CheckBox
                                    name="eulaAccepted"
                                    validations="checked"
                                    validationError={getMessage(
                                        messages,
                                        'ui.form.agreement.required'
                                    )}
                                    value={this.props.acceptedConduct}
                                    onChange={this.props.updateConductStatus}>
                                    <Message code="epic.affiliate.signup.code_of_conduct.acknowledge">
                                        <span
                                            className={styles.details}
                                            onClick={this.openConduct}
                                            dangerouslySetInnerHTML={{
                                                __html: ` ${getMessage(
                                                    messages,
                                                    'epic.affiliate.signup.code_of_conduct.conduct'
                                                )}`
                                            }}
                                        />
                                    </Message>
                                </CheckBox>
                            </div>
                        )}

                        {!loading && !failedToFetch && guardianAcknowledgment && (
                            <CheckBox
                                name="guardianAccepted"
                                validations="checked"
                                validationError={getMessage(messages, 'ui.form.agreement.required')}
                                value={this.props.guardianAccepted}
                                onChange={this.props.updateGuardianStatus}>
                                <Message code="epic.affiliate.signup.code_of_conduct.guardian.acknowledge">
                                    <span
                                        className={styles.details}
                                        onClick={this.openAffiliate}
                                        dangerouslySetInnerHTML={{
                                            __html: ` ${getMessage(
                                                messages,
                                                'epic.affiliate.signup.code_of_conduct.affiliate_agreement'
                                            )}`
                                        }}
                                    />
                                </Message>
                            </CheckBox>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
